import React, { useEffect, useState,useRef } from "react";
import moment from 'moment';
import Toast from "light-toast";
import { CALENDER_ICON, LOADING_SPIN, EXPORT_ICON } from 'assets/constants/Icons';
import MaterialTable from "material-table";
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material';
import { getS3PresignedUrl, uploadDocumentBucket, downloadDocumentBucket,getDownloadList,getUserDownloadList, createAuditLogCall,getUserDetails } from 'lib/axiosUtils';
import { INTERVAL, TYPE_FAIL } from "assets/constants/Constants";
import ShowToast from 'components/ShowToast';

const ExportPage = () => {
  const [downloadList, setDownloadList] = useState([]);
  const [fileUpload, setFileUpload] = useState([]);
  const [fileUploading, setFileUploading] = useState(false);
  const fileInputRef = useRef(null);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const userDetail = JSON.parse(localStorage.getItem("userData"));
  const userRole = JSON.parse(localStorage.getItem("userRole"));

  const getS3Key = (url) => {
    if (!url) return null;

    const s3UrlPattern = /^https:\/\/([^/]+)\.s3\.amazonaws\.com\/(.+)$/; // Match any S3 bucket URL
    const match = url.match(s3UrlPattern);

    if (match && match[2]) {
      return match[2];
    }

    return url;
  };

  const handleViewFile = async (event, url) => {
    event.preventDefault();
    const s3Key = getS3Key(url);
    const exportParams = {
      moduleName: "Report Download",
      userID: userDetail._id,
      creditUsed: "100",
      logText: "Credits Used for Report Download",
      fileType: "pdf"
    };

    if (!s3Key) {
      ShowToast('Invalid file reference', TYPE_FAIL, INTERVAL, null, "");
      return;
    }
    try {
      setDownloadLoading(true);
      const response = await downloadDocumentBucket({}, { fileKey: s3Key });

      if (!response.data?.downloadUrl) {
        throw new Error('Invalid response from server');
      }

      await createAuditLogCall({}, exportParams);

      const data = await getUserDetails({}, {},userDetail._id);
      localStorage.setItem("userData",null);
      localStorage.setItem("userData", JSON.stringify(data.data.result));

      window.open(response.data.downloadUrl, '_blank');
    } catch (err) {
      console.error('Download failed:', err);
      ShowToast(`${err.message ? err.message : "Failed to generate download link"} `, TYPE_FAIL, INTERVAL, null, "");

      if (url.startsWith('http')) {
        window.open(url, '_blank');
      }
    } finally {
      setDownloadLoading(false);
    }
  }

  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

  const handleFileUpload = async (event) => {
    event.preventDefault();
    const files = event.target.files;

    if (!files.length) return;

    Toast.loading("Uploading files, please wait...", 0);
    setFileUploading(true);

    const uploadedFiles = [];

    for (const file of files) {
      if (file.size > MAX_FILE_SIZE) {
        ShowToast(`File "${file.name}" is too large. Max 2MB allowed.`, TYPE_FAIL, INTERVAL, null, "");
        continue;
      }

      try {
        // Step 1: Get presigned URL for each file
        const response = await getS3PresignedUrl({}, {
          fileName: file.name,
          fileType: file.type,
        });

        const { url, fileUrl } = response.data;

        // Step 2: Upload to S3
        const headers = {
          "Content-Type": file.type,
        };

        await uploadDocumentBucket(headers, { url, file });

        uploadedFiles.push(fileUrl);
        Toast.success(`Uploaded: ${file.name}`, 1);
      } catch (error) {
        console.error(`Error uploading "${file.name}":`, error);
        ShowToast(`Upload failed: ${file.name}`, TYPE_FAIL, INTERVAL, null, "");
      }
    }

    setFileUploading(false);
    Toast.hide();

    if (uploadedFiles.length) {
      setFileUpload((prev) => [...(prev || []), ...uploadedFiles]);
      Toast.success(`${uploadedFiles.length} file(s) uploaded successfully`, INTERVAL);
    }
  };


  const uploadFileButton = () => {
    fileInputRef.current.click();
  }

  useEffect(() => {
    const fetchDownloadList = async () => {
      let data;
        try {
          if (userRole.user_role === "super admin") 
          {
            data = await getDownloadList({}, {});
          }else
          {
            data = await getUserDownloadList({}, {},userDetail._id);
          }

          setDownloadList(data.data.result);
        }
        catch (error) {
            console.log("error while fetching data", error);
        }
    }
        fetchDownloadList();
    },[userDetail._id, userRole.user_role]);

  const mytheme= createTheme({});
  return (<>
    {
       (
        <div className="main-content">
          <div className="pagetitle row" style={{ color: 'black', paddingTop: 15 }}>
            <div className="col-md-10 sm_device"><i className={`${EXPORT_ICON}`}></i> Export Page</div>
            <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}><i className={`${CALENDER_ICON}`}></i> {moment().format("DD MMM YYYY")}</div>
          </div>
          <div style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }} />
          <div className="list-wrapper">
          <div className="customer-button-div">
              {
                fileUploading === true ? (
                  <i className={`${LOADING_SPIN} brand-color`} />
                ) : (
                  <button className="brand-button" onClick={uploadFileButton}> Upload
                    <input
                      type="file"
                      accept="/*"
                      multiple
                      ref={fileInputRef}
                      style={{ display: 'none' }}
                      onChange={(event) => handleFileUpload(event)}
                    />
                  </button>
                )
              }
              {
                downloadLoading === true ? (
                  <i className={`${LOADING_SPIN} brand-color`} />
                ) : (
                  fileUpload.length > 0 && (
                    fileUpload.map((url) => {
                      return <button className="brand-button ml-5" onClick={(e) => handleViewFile(e, url)}>Download</button>
                    })
                  )
                )
              }

            </div>

          <div className="mt-4 border list-table-div site-table" style={{ marginBottom: 50 }}>
              {
                true ? (
                      <ThemeProvider theme={mytheme}>
                          <MaterialTable
                              columns={[
                                  {
                                      title: "Date", field: "date",
                                      cellStyle: { cellWidth: '12%', color: '#808080', fontSize: 14, textTransform: 'none' }
                                  },
                                  {
                                    title: "User", field: "user",
                                    cellStyle: { cellWidth: '18%', fontWeight: 'bolder', color: '#000000', fontSize: 14 }
                                  },
                                  {
                                      title: "Report Name", field: "module_name",
                                      cellStyle: { cellWidth: '18%', fontWeight: 'bolder', color: '#000000', fontSize: 14 }
                                  },
                                  {
                                    title: "Credits Used", field: "credit_used",
                                    cellStyle: { cellWidth: '20%', color: '#808080', fontSize: 14, textTransform: 'none' },
                                    sorting: false
                                  },
                                  {
                                      title: "Details", field: "details",
                                      cellStyle: { cellWidth: '20%', color: '#808080', fontSize: 14, textTransform: 'none' },
                                      sorting: false
                                  }
                              ].filter(Boolean)}
                              data={
                                downloadList.map((item) => {
                                    return (
                                        {
                                            user: item.full_name? item.full_name : `${userDetail.first_name} ${userDetail.last_name}`,
                                            module_name: item.module_name,
                                            details: item.log_text,   
                                            credit_used: item.credit_used,                                         
                                            date: new Date(item.created_date_time).toLocaleDateString('en-IN', {
                                              day: '2-digit',
                                              month: '2-digit',
                                              year: 'numeric',
                                              hour: '2-digit',
                                              minute: '2-digit',
                                              second: '2-digit',
                                              hour12: false 
                                          }),
                                        }
                                    )
                                })
                            }

                              options={{
                                  actionsColumnIndex: -1,
                                  headerStyle: {
                                      color: '#999998',
                                      fontWeight: 'bolder',
                                      fontSize: 15
                                  },
                                  filtering: true,
                                  sorting: true,
                                  columnsButton: true,
                                  exportButton: true,
                                  exportFileName: "Export Page Data"
                              }}
                          />
                      </ThemeProvider>
                  ) : (
                      <div className="text-center pt-2">
                          <label>Not Found</label>
                      </div>
                  )

              }
          </div>
          </div>
        </div>
      )
    }
  </>);
}

export default ExportPage;